import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const RemoveDeviceToken = createAsyncThunk('RemoveDeviceToken/getBookings', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/UserLogin/UpdatUserDeviceTokenOnLogout', params, {mode:'cors'})
    
    return response.data
    
  })

export const LogoutSlice = createSlice({
    name: 'LogoutSlice',
    initialState: {
        data: ""
    },
    reducers: {},
    extraReducers: builder => {
      builder
       
      .addCase(RemoveDeviceToken.fulfilled, (state, action) => {
                 
        state.data = action.payload.data
    })
    }
})

export default LogoutSlice.reducer